/* tslint:disable:max-line-length */
import classNames from 'classnames';
import React from 'react';
import { IconTypeProps } from '../types';

export const MenuIntegrationsIcon = ({
  className,
  style: styleFromProps,
  onClick,
  size,
  color = '#6794BA',
  colorSecondary = '#B9D2E5',
}: IconTypeProps) => {
  const style = {
    ...styleFromProps,
    ...(size ? { width: size, height: size } : {}),
  };
  return (
    <svg
      className={classNames(className)}
      onClick={onClick}
      style={style}
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.0447 27.9547C11.0684 26.9783 11.0684 25.3954 12.0447 24.4191L24.4191 12.0447C25.3954 11.0684 26.9783 11.0684 27.9547 12.0447C28.931 13.0211 28.931 14.604 27.9547 15.5803L15.5802 27.9547C14.604 28.931 13.021 28.931 12.0447 27.9547Z"
        fill={color}
      />
      <path
        d="M27.7207 21.0316C25.3818 21.0316 23.187 20.1209 21.5341 18.4681C19.8813 16.8153 18.9707 14.6205 18.9707 12.2816C18.9707 9.94516 19.8813 7.74789 21.5341 6.095L25.0693 2.55984C28.4824 -0.853281 34.0293 -0.853281 37.4423 2.55984C40.853 5.97047 40.853 11.5223 37.4423 14.9329L33.9072 18.468C32.2545 20.1209 30.0572 21.0316 27.7207 21.0316ZM31.2559 4.99883C30.2964 4.99883 29.3345 5.36508 28.6045 6.095L25.0693 9.63016C24.3613 10.3381 23.9707 11.2805 23.9707 12.2816C23.9707 13.2826 24.3613 14.2249 25.0693 14.933C26.4853 16.349 28.956 16.349 30.372 14.933L33.9072 11.3978C35.3696 9.93539 35.3696 7.5575 33.9072 6.09508C33.1773 5.36508 32.2154 4.99883 31.2559 4.99883Z"
        fill={colorSecondary}
      />
      <path
        d="M25.0693 14.933C24.4102 14.274 24.0266 13.4117 23.9766 12.4883L20.0205 16.4444C20.4192 17.179 20.9262 17.8603 21.5341 18.4682C22.1413 19.0754 22.8218 19.582 23.5555 19.9805L27.5449 15.9911C26.6328 15.9509 25.7346 15.5984 25.0693 14.933Z"
        fill={color}
      />
      <path
        d="M8.75 40.0003C6.41109 40.0003 4.21633 39.0897 2.56344 37.4369C0.910625 35.784 0 33.5892 0 31.2503C0 28.9139 0.910625 26.7166 2.56344 25.0637L6.09859 21.5286C9.51172 18.1155 15.0586 18.1155 18.4716 21.5286C21.8823 24.9392 21.8823 30.491 18.4716 33.9016L14.9365 37.4368C13.2837 39.0897 11.0864 40.0003 8.75 40.0003ZM12.2852 23.9676C11.3257 23.9676 10.3637 24.3338 9.63375 25.0637L6.09859 28.5989C5.39062 29.307 5 30.2494 5 31.2503C5 32.2512 5.39062 33.1937 6.09859 33.9017C7.51461 35.3177 9.98531 35.3177 11.4013 33.9017L14.9365 30.3666C16.3989 28.9041 16.3989 26.5262 14.9365 25.0638C14.2066 24.3338 13.2446 23.9676 12.2852 23.9676Z"
        fill={colorSecondary}
      />
      <path
        d="M18.4718 21.5279C17.8577 20.9138 17.1741 20.4107 16.4467 20.0176L12.4912 23.973C13.3813 24.0217 14.2589 24.3853 14.9367 25.063C15.6154 25.7418 15.9786 26.6178 16.0273 27.508L19.9818 23.5535C19.5887 22.8257 19.0858 22.142 18.4718 21.5279Z"
        fill={color}
      />
    </svg>
  );
};
